import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider from '../../Modules/Slider.js';
import * as CustomScroll from '../../Modules/CustomScroll.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import FadeAnimation from '../../Modules/FadeAnimation.js';
import BlurredSlideAnimation from '../../Modules/BlurredSlideAnimation.js';
import HamMenu from '../../Modules/HamMenu.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  Slider();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  new FadeAnimation({
    threshold: 0.5,
  });
  new BlurredSlideAnimation({
    threshold: 0.5,
  });
  HamMenu.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
}

const resizeW = () => {
  CustomProperty.resizeW();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
  HamMenu.scrollShow();
}

const load = () => {
  UpdateStatus.load();
  Animation();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
